module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Drop here":"Drop field here"},"de":{"Drop here":"Feld hierher ziehen"}}')
  delete Component.options._Ctor
}
